window.theme = window.theme || {};

// Remove "reviews" text from Judge.me badges, keep only the number
document.addEventListener('DOMContentLoaded', function() {
  function removeReviewsText() {
    const reviewTexts = document.querySelectorAll('.jdgm-prev-badge__text');
    
    reviewTexts.forEach(function(element) {
      // Only process if not already processed
      if (!element.hasAttribute('data-processed')) {
        // Replace "X reviews" with just "X"
        const reviewCount = element.textContent.match(/\d+/);
        if (reviewCount) {
          element.textContent = reviewCount[0];
          element.setAttribute('data-processed', 'true');
        }
      }
    });
  }
  
  // Run immediately and then every 2 seconds for the first 30 seconds
  removeReviewsText();
  
  let attempts = 0;
  const maxAttempts = 15; // 30 seconds total
  const intervalId = setInterval(function() {
    removeReviewsText();
    attempts++;
    
    if (attempts >= maxAttempts) {
      clearInterval(intervalId);
      console.log('Stopped checking for review badges');
    }
  }, 2000);
  
  // Also listen for page changes/navigation
  window.addEventListener('popstate', function() {
    setTimeout(removeReviewsText, 500);
  });
  
  // Listen for any clicks that might load new content
  document.addEventListener('click', function(e) {
    // If clicking on filter/sort elements, wait and then process
    if (e.target.closest('.facets') || e.target.closest('[data-facet]') || e.target.closest('.facet-filters__sort')) {
      setTimeout(removeReviewsText, 1000);
      setTimeout(removeReviewsText, 3000);
    }
  });
});

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    "shopify:section:load",
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    "shopify:section:unload",
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    "shopify:section:select",
    this._onSelect.bind(this)
  );
  document.addEventListener(
    "shopify:section:deselect",
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    "shopify:block:select",
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    "shopify:block:deselect",
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var id = container.getAttribute("data-section-id");
    var type = container.getAttribute("data-section-type");

    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = this.instances.filter(function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === "function") {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onSelect === "function"
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onDeselect === "function"
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockSelect === "function"
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockDeselect === "function"
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function (container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

theme.collectionSlider = (function () {
  function sliderProduct(e) {
    let sliderContainer = "",
      extraLargeDesktopShow = 4,
      largeDesktopShow = 3,
      tabletShow = 3,
      mobileShow = 2,
      sliderRows = parseInt(e.dataset.sliderRows),
      sliderGrid = "column",
      sliderLoop = e.dataset.loop;

    if (sliderLoop === "true") {
      sliderLoop = true;
    } else {
      sliderLoop = false;
    }

    if (sliderRows > 1) {
      sliderGrid = "row";
      sliderLoop = false;
    }
    if (e.dataset.sliderEnable === "true") {
      sliderContainer = e.querySelector(".productSlider");
      extraLargeDesktopShow = parseInt(e.dataset.showExtraLarge);
      largeDesktopShow = parseInt(e.dataset.showLarge);
      tabletShow = parseInt(e.dataset.showTablet);
      mobileShow = parseInt(e.dataset.showMobile);
    }

    var swiper = new Swiper(sliderContainer, {
      loop: sliderLoop,
      slidesPerView: mobileShow,
      spaceBetween: 20,
      grid: {
        rows: sliderRows,
        fill: sliderGrid,
      },
      pagination: {
        el: e.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: e.querySelector(".product_slider_wrapper .swiper-button-next"),
        prevEl: e.querySelector(".product_slider_wrapper .swiper-button-prev"),
      },
      breakpoints: {
        640: {
          slidesPerView: mobileShow,
        },
        750: {
          slidesPerView: tabletShow,
        },
        992: {
          slidesPerView: largeDesktopShow,
        },
        1200: {
          slidesPerView: extraLargeDesktopShow,
        },
      },
    });
    // Slide thumbnail height
    const slideThumbHeight = () => {
      const proudctThumbnails = e.querySelectorAll(".card--client-height");
      if (proudctThumbnails.length > 0) {
        const productThumbnailHeight = proudctThumbnails[0];
        e.style.setProperty(
          "--slider-navigation-top-offset",
          `${productThumbnailHeight.clientHeight / 2}px`
        );
      }
    };
    slideThumbHeight();
    window.addEventListener("resize", () => {
      slideThumbHeight();
    });
  }
  return sliderProduct;
})();

document.addEventListener("DOMContentLoaded", function () {
  let sections = new theme.Sections(),
    headerSearchModule = new theme.Sections(),
    headerCartModule = new theme.Sections(),
    headerStickyModule = new theme.Sections();

  sections.register("announcement-bar", theme.announcement);
  sections.register("header", theme.headerSection);
  sections.register("header", theme.headerCategoryMenu);
  headerSearchModule.register("header", theme.headerSearch);
  headerStickyModule.register("header", theme.headerSticky);
  sections.register("footer", theme.footerSection);
  sections.register("slideShow", theme.SlideShow);
  sections.register("product-tab", theme.productTab);
  sections.register("collection-product", theme.collectionProduct);
  sections.register("product-slider", theme.collectionSlider);
  sections.register("counter_up", theme.counterup);
  sections.register("faq-collapse", theme.accordion);
  sections.register("popup-video", theme.video);
  sections.register("lookbook", theme.lookbookSlider);
  sections.register("timeline", theme.timelineSlider);
});

// ----- Add to Cart Functionality START -----
document.addEventListener('DOMContentLoaded', function() {
  const addToCartButtons = document.querySelectorAll('.product__add_to_cart_button');

  addToCartButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();

      const productHandle = this.dataset.productHandle;
      const variantId = this.dataset.variantId;

      const currentButton = this; // Store reference to the button
      const originalButtonText = currentButton.innerHTML;

      // Disable button and add loading state
      currentButton.disabled = true;
      currentButton.classList.add('loading');
      // Optionally, change text: currentButton.innerHTML = 'Přidávám...';

      const finallyActions = () => {
        // Remove loading state and re-enable button
        currentButton.classList.remove('loading');
        currentButton.disabled = false;
        // Restore original text if it was changed: currentButton.innerHTML = originalButtonText;
      };

      if (variantId) {
        addItemToCart(variantId, 1, currentButton, finallyActions);
      } else if (productHandle) {
        fetch(`/products/${productHandle}.js`)
          .then(response => response.json())
          .then(product => {
            if (product && product.variants) {
              let cheapestVariant = product.variants.reduce((min, variant) => 
                parseFloat(variant.price) < parseFloat(min.price) ? variant : min, 
                product.variants[0]
              );
              if (cheapestVariant && cheapestVariant.id) {
                addItemToCart(cheapestVariant.id, 1, currentButton, finallyActions);
              } else {
                console.error('Cheapest variant ID not found for product:', productHandle);
                alert('Error: Could not find variant information.');
                finallyActions(); 
              }
            } else {
              console.error('Product data or variants not found for handle:', productHandle);
              alert('Error: Product data not found.');
              finallyActions();
            }
          })
          .catch(error => {
            console.error('Error fetching product data:', error);
            alert('Error fetching product details. Please try again.');
            finallyActions();
          });
      } else {
        console.error('No product handle or variant ID found on button:', currentButton);
        alert('Error: Missing product information.');
        finallyActions();
      }
    });
  });

  function addItemToCart(variantId, quantity, buttonElement, callback) {
    const formData = {
      'items': [{
        'id': variantId,
        'quantity': quantity
      }]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(cartData => {
      if (cartData.status === 'bad_request' || (cartData.items && cartData.items.length > 0 && cartData.items[0].quantity === 0 && cartData.items[0].id === variantId) || cartData.message === "Cart Error") {
        let errorMessage = 'Error adding to cart.';
        if (cartData.description) {
            errorMessage = cartData.description;
        } else if (cartData.message) {
            errorMessage = cartData.message;
        }
        alert(errorMessage);
        console.error('Error adding item to cart:', errorMessage, cartData);
      } else if (cartData.items && cartData.items.length > 0) {
        updateSidecartAndIcon(); // Removed buttonElement from here, not needed for UI update
      } else {
        console.warn('Item might not have been added to cart. Response:', cartData);
        updateSidecartAndIcon(); // Still try to update UI
      }
    })
    .catch(error => {
      console.error('Error adding item to cart:', error);
      alert('Error adding item to cart. Please try again.');
    })
    .finally(() => {
      if (typeof callback === 'function') {
        callback();
      }
    });
  }

  function updateSidecartAndIcon() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartIconCount = document.getElementById('cart-notification-count');
        if (cartIconCount) {
          cartIconCount.textContent = cart.item_count;
        }
        // Shopify might also have a cart bubble that needs updating, e.g., inside a header-drawer
        const cartBubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
        if (cartBubble) {
            cartBubble.textContent = cart.item_count;
        }
        const cartBubbleDesktop = document.querySelector('#cart-icon-bubble span[aria-hidden="true"]');
         if (cartBubbleDesktop) {
            cartBubbleDesktop.textContent = cart.item_count;
        }


        return fetch('?section_id=mini-cart-drawer'); 
      })
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newSidecartDrawerContent = doc.querySelector('#mini-cart-drawer');
        
        const sidecartDrawer = document.getElementById('mini-cart-drawer');
        if (sidecartDrawer && newSidecartDrawerContent) {
          sidecartDrawer.innerHTML = newSidecartDrawerContent.innerHTML;
          // Ensure event listeners for new content are re-attached if necessary
          // For example, the close button within the new mini-cart
          const closeButton = sidecartDrawer.querySelector('.mini-cart__close');
          if (closeButton) {
            closeButton.addEventListener('click', (e) => {
              e.preventDefault();
              sidecartDrawer.classList.remove('active');
              document.body.classList.remove('added__overlay');
            });
          }
        } else if (!newSidecartDrawerContent) {
            console.error("Could not find #mini-cart-drawer in fetched HTML for section.");
            return; // Stop if we can't update the sidecart
        }
        
        // Open the sidecart
        if (sidecartDrawer) sidecartDrawer.classList.add('active');
        document.body.classList.add('added__overlay');

        // Ensure overlay click closes the cart
        const overlay = document.querySelector('body.added__overlay'); // More specific selector
        if (overlay) {
            // Remove existing listener to prevent duplicates if this function is called multiple times
            const newOverlay = overlay.cloneNode(true);
            overlay.parentNode.replaceChild(newOverlay, overlay);
            newOverlay.addEventListener('click', function() {
                if(sidecartDrawer) sidecartDrawer.classList.remove('active');
                document.body.classList.remove('added__overlay');
            });
        }
      })
      .catch(error => {
        console.error('Error updating sidecart or icon:', error);
      });
  }

  // Initial setup for sidecart close button and overlay click, if sidecart can be initially open or manipulated by other scripts
  function initializeSidecartInteractions() {
    const sidecartDrawer = document.getElementById('mini-cart-drawer');
    if (!sidecartDrawer) return;

    const closeButton = sidecartDrawer.querySelector('.mini-cart__close');
    if (closeButton) {
      closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        sidecartDrawer.classList.remove('active');
        document.body.classList.remove('added__overlay');
      });
    }
  }
  initializeSidecartInteractions(); // Call it on DOMContentLoaded

});

// ----- Add to Cart Functionality END -----
